import React, { useEffect, useState } from "react";
import NavBar from "../../../component/b2c/navBar/navBar";
import Sidebar from "../../../component/b2c/sidebar/sidebar";
import { useMyContext } from "../../../context/MyContext";
import { useNavigate } from "react-router-dom";
import { Base_Url, dashboard, shipmentList, userdata } from "../../../config/config";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";
import ImageOfferSlider from "../../../component/Alloffers/alloffer";
import {
  Package,
  AlertTriangle,
  Wallet,
  Scale,
  ShoppingBag,
  TrendingUp,
  CheckCircle2,
  CreditCard,
  ArrowUpRight,
  Loader2,
  Inbox,
  Trophy,
  Truck,
  Clock,
  Sun,
  Moon,
  Sunrise,
  Sunset,
  ShieldAlert,
  X,
} from "lucide-react";

export default function DashBoard() {
  const { isToggleSidebar, isDarkMode } = useMyContext();
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    data: {},
    chartData: { monthlyData: [] },
  });
  const [orders, setOrders] = useState([]);
  const [allOrders, setAllOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const token = localStorage.getItem("token");
  const cusid = localStorage.getItem("cus_id");

  // ── KYC Pending Popup + Marquee logic ──
  const profile_flag = localStorage.getItem("profile_flag");
  const isKycPending = profile_flag === "0";
  const [showKycPopup, setShowKycPopup] = useState(false);

  const handlePageClick = () => {
    if (isKycPending) {
      setShowKycPopup(true);
    }
  };

  // ── Greeting + Live Clock state ──
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // ── Real user name (same source/logic as NavBar) ──
  const [userName, setUserName] = useState("User");

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser && storedUser.userData && storedUser.userData.name) {
      setUserName(storedUser.userData.name);
    }
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    const url = Base_Url + userdata;
    if (cusid) {
      try {
        const response = await fetch(url + "/" + cusid, {
          method: "GET",
          headers: {
            token: token,
            cus_id: cusid,
            "Content-Type": "application/json",
          },
        });
        const result = await response.json();
        if (result?.data?.name) {
          setUserName(result.data.name);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    }
  };

  const getGreeting = () => {
    const hour = currentTime.getHours();
    if (hour >= 5 && hour < 12) {
      return { text: "Good Morning", Icon: Sunrise };
    } else if (hour >= 12 && hour < 17) {
      return { text: "Good Afternoon", Icon: Sun };
    } else if (hour >= 17 && hour < 21) {
      return { text: "Good Evening", Icon: Sunset };
    } else {
      return { text: "Good Night", Icon: Moon };
    }
  };

  const { text: greetingText, Icon: GreetingIcon } = getGreeting();

  const formattedTime = currentTime.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  const formattedDate = currentTime.toLocaleDateString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const dummy = { data: {}, chartData: { monthlyData: [] } };

  useEffect(() => {
    load();
  }, []);
  const load = async () => {
    setLoadingOrders(true);
    try {
      const r1 = await fetch(Base_Url + dashboard, {
        method: "GET",
        headers: {
          token: token,
          cus_id: cusid,
          "Content-Type": "application/json",
        },
      });
      const j1 = await r1.json();
      setStats(j1?.data ? j1 : dummy);
    } catch {
      setStats(dummy);
    }
    try {
      const r2 = await fetch(`${Base_Url}${shipmentList}`, {
        method: "GET",
        headers: {
          token: token,
          cus_id: cusid,
          "Content-Type": "application/json",
        },
      });
      const j2 = await r2.json();

      console.log("shipment api response", j2);
      const pendingData = Array.isArray(j2?.data)
        ? j2.data
        : Array.isArray(j2?.rows)
          ? j2.rows
          : Array.isArray(j2)
            ? j2
            : [];
      setAllOrders(pendingData);
      setOrders(
        pendingData.filter((item) =>
          String(item.status || "")
            .toLowerCase()
            .includes("pending")
        )
      );
      const r3 = await fetch(`${Base_Url}${shipmentList}?status=pending`, {
        method: "GET",
        headers: {
          token: token,
          cus_id: cusid,
          "Content-Type": "application/json",
        },
      });
      const j3 = await r3.json();
      const pendingOnly = Array.isArray(j3?.data)
        ? j3.data
        : Array.isArray(j3?.rows)
          ? j3.rows
          : [];
      if (pendingOnly.length) {
        setOrders(pendingOnly);
      }
      setLoadingOrders(false);
    } catch {
      setOrders([]);
      setLoadingOrders(false);
    }
  };

  // ── Card meta: icon + icon-chip colors (purely presentational) ──
  const cardMeta = [
    { icon: Package, iconBg: "bg-emerald-50 dark:bg-emerald-500/10", iconColor: "text-emerald-500 dark:text-emerald-300" },
    { icon: AlertTriangle, iconBg: "bg-blue-50 dark:bg-blue-500/10", iconColor: "text-blue-500 dark:text-blue-300" },
    { icon: Wallet, iconBg: "bg-purple-50 dark:bg-purple-500/10", iconColor: "text-purple-500 dark:text-purple-300" },
    { icon: Scale, iconBg: "bg-gray-100 dark:bg-gray-500/10", iconColor: "text-gray-500 dark:text-gray-300" },
    { icon: ShoppingBag, iconBg: "bg-orange-50 dark:bg-orange-500/10", iconColor: "text-orange-500 dark:text-orange-300" },
    { icon: TrendingUp, iconBg: "bg-blue-50 dark:bg-blue-500/10", iconColor: "text-blue-500 dark:text-blue-300" },
    { icon: CheckCircle2, iconBg: "bg-cyan-50 dark:bg-cyan-500/10", iconColor: "text-cyan-500 dark:text-cyan-300" },
    { icon: CreditCard, iconBg: "bg-rose-50 dark:bg-rose-500/10", iconColor: "text-rose-500 dark:text-rose-300" },
  ];

  const cards = [
    {
      title: "Orders",
      value: stats?.data?.total_order || orders.length,
      bg: "from-emerald-500 to-green-600",
    },
    {
      title: "NDR & RTO",
      value:
        (stats?.data?.total_ndr || 0) +
        (stats?.data?.total_rto || 0),
      bg: "from-teal-500 to-cyan-600",
    },
    {
      title: "COD Remittance",
      value:
        stats?.data?.cod_remittance || "₹0",
      bg: "from-amber-500 to-orange-500",
    },
    {
      title: "Weight Disputes",
      value:
        stats?.data?.weight_disputes || 0,
      bg: "from-orange-500 to-yellow-500",
    },
    {
      title: "Integration",
      value:
        stats?.data?.woo_sales ||
        stats?.data?.woocommerce_sales ||
        "₹0",
      bg: "from-pink-500 to-rose-600",
    },
    {
      title: "Delivery Rate",
      value: `${stats?.data?.delivery_rate ||
        (stats?.data?.total_order
          ? Math.round(
            ((stats?.data?.total_delivered ||
              0) /
              stats?.data?.total_order) *
            100
          )
          : 0)
        }%`,
      bg: "from-violet-600 to-purple-700",
    },
  ];

  const formatCurrency = (value) =>
    new Intl.NumberFormat("en-IN", {
      notation: "compact",
      maximumFractionDigits: 1,
    }).format(value || 0);

  const partners = Object.entries(stats?.data?.partnerPerformance || {})
    .map(([key, value]) => {
      const done = value?.delivred ?? 0;
      const inprocess = value?.in_process ?? 0;

      return {
        name: key,
        total: done + inprocess,
        done,
        inprocess
      };
    })
    .sort((a, b) => b.total - a.total)
    .slice(0, 5);

  // shared glass classes
  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

  // ── shared mini-stat box style (the bordered glass pill used inside each card) ──
  const miniStat =
    "rounded-lg border border-white/70 dark:border-white/10 bg-white/45 dark:bg-white/[0.05] " +
    "backdrop-blur-md px-2 py-1.5 shadow-lg";

  return (
    <div
      className="h-screen flex flex-col relative overflow-hidden bg-gradient-to-br from-slate-100 via-indigo-50 to-sky-100 dark:from-[#0b0f1a] dark:via-[#0d1220] dark:to-[#0a0e18] transition-colors"
      onClick={handlePageClick}
    >

      <div className="relative z-10 flex flex-col h-full">
        <NavBar />

        {/* ── KYC Pending Marquee ── */}
        {isKycPending && (
          <div className="w-full bg-red-600 text-white overflow-hidden py-1.5 shadow-md">
            <marquee behavior="scroll" direction="left" scrollamount="6">
              ⚠️ Your KYC verification is pending. Please complete your KYC to access all features. Click anywhere to update your KYC now.
            </marquee>
          </div>
        )}

        <div className="flex flex-1 overflow-hidden">
          {/*
            Sidebar wrapper now always renders. isToggleSidebar controls
            whether it's the full (w-64) sidebar or the collapsed
            icon-only rail (w-[72px]) — it no longer hides it completely.
          */}
          <div
            className={`
              ${isToggleSidebar ? "w-64" : "w-[72px]"}
              m-3
              rounded-3xl
              ${glass}
              overflow-hidden
              transition-all
              duration-300
              ease-in-out
            `}
          >
            <Sidebar />
          </div>
          <div className="flex-1 overflow-auto p-2 lg:p-2">

            {/* ── Greeting + Live Clock ── */}
            <div className={`rounded-[15px] ${glass} mb-3 px-4 py-3 flex items-center justify-between flex-wrap gap-2`}>
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-[13px] ring-1 ring-white/50 dark:ring-white/10 text-amber-500 dark:text-amber-300 bg-amber-50 dark:bg-amber-500/10">
                  <GreetingIcon size={20} strokeWidth={1.8} />
                </div>
                <div>
                  <div className="text-sm font-bold text-slate-900 dark:text-white leading-tight">
                    {greetingText}, {userName}!
                  </div>
                  <div className="text-[11px] text-slate-500 dark:text-gray-400">
                    {formattedDate}
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-2 rounded-full bg-white/40 dark:bg-white/5 border border-black/10 dark:border-white/10 px-3.5 py-1.5 backdrop-blur-md shadow-md">
                <Clock size={20} className="text-indigo-500 dark:text-indigo-300" />
                <span className="text-xl font-semibold tabular-nums text-slate-800 dark:text-gray-200">
                  {formattedTime}
                </span>
              </div>
            </div>

            {/* ── Stat cards (glassmorphic, file-1 style) ── */}
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
              {cards.map((c, i) => {
                const meta = cardMeta[i] || cardMeta[0];
                const Icon = meta.icon;
                return (
                  <div
                    key={i}
                    className="
                      group
                      relative
                      min-w-0
                      overflow-hidden
                      rounded-[15px]
                      border border-t border-l
                      shadow-xl
                      border-white/60
                      dark:border-white/[0.08]
                      bg-gradient-to-br
                      from-white/80
                      via-white/55
                      to-white/35
                      dark:from-white/[0.09]
                      dark:via-white/[0.05]
                      dark:to-white/[0.02]
                      pl-2 pr-2 py-2
                      backdrop-blur-2xl
                      backdrop-saturate-150
                      transition-all
                      duration-300
                      hover:-translate-y-1
                      hover:border-white/80
                      dark:hover:border-white/[0.14]
                      hover:bg-gradient-to-br
                      hover:from-white/95
                      hover:via-white/70
                      hover:to-white/45
                      dark:hover:from-white/[0.13]
                      dark:hover:via-white/[0.07]
                      dark:hover:to-white/[0.03]
                      hover:shadow-[0_20px_50px_rgba(15,23,42,0.12)]
                    "
                  >
                    {/* GLASS HIGHLIGHT */}
                    <div
                      className="
                        pointer-events-none
                        absolute
                        -right-1
                        -top-8
                        h-20
                        w-20
                        rounded-full
                        bg-white/70
                        dark:bg-white/[0.12]
                        blur-2xl
                      "
                    />
                    {/* TOP SHEEN LINE — subtle Apple-glass inner edge */}
                    <div
                      className="
                        pointer-events-none
                        absolute
                        inset-x-0
                        top-0
                        h-px
                        bg-gradient-to-r
                        from-transparent
                        via-white/80
                        dark:via-white/20
                        to-transparent
                      "
                    />

                    {/* ICON */}
                    <div className="flex justify-between  items-center relative">


                      <div
                        className={`
                        relative
                        flex
                        h-10
                        w-10
                        items-center
                        justify-center
                        rounded-[13px]
                        ring-1
                        ring-white/50
                        dark:ring-white/10
                       
                        
                        ${meta.iconColor}
                      `}
                      >
                        <Icon size={20} strokeWidth={1.8} />
                      </div>

                      {/* TITLE */}
                      <div className="pr-2">
                        <div className=" text-[10px] text-right font-medium text-slate-500 dark:text-gray-400">
                          {c.title}
                        </div>

                        {/* VALUE */}
                        <div className=" text-[14px] text-right font-bold text-slate-900 dark:text-white">
                          {c.value}
                        </div>
                      </div>
                    </div>

                    {/* DETAILS (data untouched — only restyled) */}
                    <div className="relative mt-1 border-t border-dashed border-slate-300/70 dark:border-white/[0.12] pt-1 text-[10.5px] text-slate-500 dark:text-gray-400">

                      {i === 0 && (
                        <div className=" ">
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Delivered</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">
                              {stats?.data?.total_delivered || 0}
                            </div>
                          </div>
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">COD</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">
                              {stats?.data?.total_cod || 0}
                            </div>
                          </div>
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Prepaid</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">
                              {stats?.data?.total_prepaid || 0}
                            </div>
                          </div>
                        </div>
                      )}

                      {i === 1 && (
                        <div className="">
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">NDR</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.total_ndr || 0}</div>
                          </div>
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">RTO</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.total_rto || 0}</div>
                          </div>
                        </div>
                      )}

                      {i === 2 && (
                        <div className="">
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Last</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.last_remittance || "₹0"}</div>
                          </div>
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Next</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.next_remittance || "₹0"}</div>
                          </div>
                        </div>
                      )}

                      {i === 3 && (
                        <div className="">
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Open</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.weight_disputes || 0}</div>
                          </div>
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Resolved</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.resolved_disputes || 0}</div>
                          </div>
                        </div>
                      )}

                      {i === 4 && (
                        <div className="">
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Orders</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.woo_orders || 0}</div>
                          </div>
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Sales</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.woo_sales || "₹0"}</div>
                          </div>
                        </div>
                      )}

                      {i === 5 && (
                        <div className="">
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Delivered</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.total_delivered || 0}</div>
                          </div>
                          <div className="flex justify-between px-2 items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Rate</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.delivery_rate || "91%"}</div>
                          </div>
                        </div>
                      )}

                      {i === 6 && (
                        <div className="">
                          <div className="flex justify-between items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">COD</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.total_cod || 0}</div>
                          </div>
                          <div className="flex justify-between items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Prepaid</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.total_prepaid || 0}</div>
                          </div>
                        </div>
                      )}

                      {i === 7 && (
                        <div className="">
                          <div className="flex justify-between items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Total</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.total_order || orders.length}</div>
                          </div>
                          <div className="flex justify-between items-center">
                            <div className="truncate text-[10px] font-medium text-slate-500 dark:text-gray-400">Rate</div>
                            <div className="mt-0.5 text-xs font-semibold text-slate-800 dark:text-gray-200">{stats?.data?.delivery_rate || "91%"}</div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            {/* ── Revenue chart + offers ── */}
            <div className="grid grid-cols-1 xl:grid-cols-3 gap-2 mt-2">
              <div className={`xl:col-span-1 rounded-3xl ${glass} p-3`}>
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <div className="font-semibold text-slate-800 dark:text-gray-100">
                      Revenue Growth
                    </div>
                    <div className="text-xs text-slate-500 dark:text-gray-400">Monthly sales trend</div>
                  </div>
                </div>

                <div className="h-60">
                  <ResponsiveContainer width="100%">
                    <LineChart data={stats?.chartData?.monthlyData || []} margin={{ top: 4, right: 8, left: -24, bottom: -6 }}>
                      <defs>
                        <linearGradient id="revenueStroke" x1="0" y1="0" x2="1" y2="0">
                          <stop offset="0%" stopColor="#6366f1" />
                          <stop offset="100%" stopColor="#0ea5e9" />
                        </linearGradient>
                      </defs>
                      <CartesianGrid strokeDasharray="3 3" stroke="rgba(148,163,184,0.25)" vertical={false} />
                      <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#94a3b8" }} axisLine={{ stroke: "rgba(148,163,184,0.3)" }} tickLine={false} />
                      <YAxis tickFormatter={formatCurrency} tick={{ fontSize: 12, fill: "#94a3b8" }} axisLine={false} tickLine={false} />
                      <Tooltip
                        contentStyle={{
                          borderRadius: 16,
                          border: "1px solid rgba(255,255,255,0.6)",
                          background: "rgba(255,255,255,0.7)",
                          backdropFilter: "blur(12px)",
                          boxShadow: "0 8px 32px rgba(31,41,55,0.12)",
                          fontSize: 12,
                        }}
                        formatter={(value) => [`₹${formatCurrency(value)}`, "Revenue"]}
                      />
                      <Line
                        type="monotone"
                        dataKey="total_sales"
                        strokeWidth={3}
                        stroke="url(#revenueStroke)"
                        dot={{ r: 3, fill: "#4f46e5", strokeWidth: 0 }}
                        activeDot={{ r: 5 }}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>


              <div className={`rounded-3xl ${glass} overflow-hidden`}>
                <ImageOfferSlider />
              </div>


              <div className={`rounded-3xl ${glass}  p-3`}>
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h2 className="font-semibold text-slate-800 text-[12px] dark:text-gray-100">
                       Partner Performance
                    </h2>
                  </div>
                  <span className="hidden sm:inline-flex items-center shadow-md gap-1.5 text-[10px] font-medium text-slate-500 dark:text-gray-400 bg-white/40 dark:bg-white/5 border border-white/50 dark:border-white/10 rounded-full px-3 py-1 backdrop-blur-md">
                    <Truck size={12} /> Live volume
                  </span>
                </div>

                             <div className="rounded-2xl overflow-hidden backdrop-blur-xl bg-white/30 dark:bg-white/[0.03] border border-white/50 dark:border-white/10">

                  {/* ── MOBILE STACKED VIEW ── */}
                  <div className="block md:hidden p-3 space-y-2.5">
                    {partners.map((p, i) => {
                      const pct = p.total ? Math.round((p.done / p.total) * 100) : 0;
                      const rankTint = [
                        "bg-amber-400/25 text-amber-700 dark:text-amber-300",
                        "bg-slate-400/25 text-slate-700 dark:text-slate-200",
                        "bg-orange-400/20 text-orange-700 dark:text-orange-300",
                        "bg-indigo-400/15 text-indigo-700 dark:text-indigo-300",
                        "bg-indigo-400/15 text-indigo-700 dark:text-indigo-300",
                      ][i] || "bg-indigo-400/15 text-indigo-700 dark:text-indigo-300";
                      return (
                        <div
                          key={i}
                          className="rounded-2xl p-3.5 backdrop-blur-xl bg-gradient-to-br from-white/80 via-white/55 to-white/35 dark:from-white/[0.09] dark:via-white/[0.05] dark:to-white/[0.02] border border-white/60 dark:border-white/[0.08] shadow-[0_8px_32px_rgba(15,23,42,0.06)]"
                        >
                          <div className="flex items-center justify-between mb-2.5">
                            <div className="flex items-center gap-2">
                              <span className={`inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full ${rankTint}`}>
                                {i === 0 && <Trophy size={10} />}
                                #{i + 1}
                              </span>
                              <div className="flex items-center justify-center h-7 rounded-xl bg-white/60 dark:bg-white/5 backdrop-blur-md px-2">
                                {p.name?.toLowerCase() === "delhivery" && (
                                  <img
                                    src={
                                      isDarkMode
                                        ? "/assets/images/DelhiveryWhite.png"
                                        : "/assets/images/Delhivery.png"
                                    }
                                    alt="Delhivery"
                                    className="h-4 w-auto object-contain"
                                  />
                                )}
                                {p.name?.toLowerCase() === "ecom" && (
                                  <img
                                    src={
                                      isDarkMode
                                        ? "/assets/images/logoecom.svg"
                                        : "/assets/images/ecom-express-logo.png"
                                    }
                                    alt="Ecom Express"
                                    className="h-8 w-auto object-contain"
                                  />
                                )}
                                {p.name?.toLowerCase() === "ekart" && (
                                  <img
                                    src="/assets/images/ekart.png"
                                    alt="Ekart"
                                    className="h-8 w-auto object-contain"
                                  />
                                )}
                                {p.name?.toLowerCase() === "xpressbees" && (
                                  <img
                                    src="/assets/images/xpressbess.png"
                                    alt="xpressbess"
                                    className="h-4 w-auto object-contain"
                                  />
                                )}
                                {p.name?.toLowerCase() === "bluedart" && (
                                  <div className="flex items-center">
                                    <img
                                      src="/assets/images/bluedart.png"
                                      alt="bluedart"
                                      className="h-[10px] w-auto object-contain"
                                    />
                                  </div>
                                )}
                                {!["delhivery", "ecom", "ekart", "xpressbees", "bluedart"].includes(
                                  p.name?.toLowerCase()
                                ) && (
                                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-white/60 dark:bg-white/10 text-slate-700 dark:text-gray-200 backdrop-blur-md">
                                      {p.name || "Not Available"}
                                    </span>
                                  )}
                              </div>
                            </div>
                            <span className="text-[10px] px-2 py-0.5 rounded-full bg-white/60 dark:bg-white/10 ring-1 ring-white/50 dark:ring-white/10 font-semibold text-slate-600 dark:text-gray-300">
                              {pct}%
                            </span>
                          </div>

                          <div className="flex items-center justify-between mb-1.5">
                            <span className="text-[11px] text-slate-500 dark:text-gray-400">Total shipments</span>
                            <span className="text-xs font-bold text-slate-900 dark:text-white">{p.total}</span>
                          </div>
                          <div className="w-full h-1.5 bg-white/50 dark:bg-white/10 rounded-full overflow-hidden backdrop-blur-md">
                            <div
                              className="h-full bg-gradient-to-r from-indigo-500 to-sky-500 rounded-full transition-all duration-500"
                              style={{ width: `${pct}%` }}
                            ></div>
                          </div>
                          <div className="flex items-center justify-between mt-2.5 text-[11px]">
                            <span className="inline-flex items-center gap-1 text-emerald-600 dark:text-emerald-400 font-medium">
                              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> {p.done} delivered
                            </span>
                            <span className="inline-flex items-center gap-1 text-blue-600 dark:text-blue-400 font-medium">
                              <span className="h-1.5 w-1.5 rounded-full bg-blue-500" /> {p.inprocess} active
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* ── DESKTOP TABLE VIEW ── */}
                  <div className="hidden md:block overflow-auto">
                    <table className="w-full border-collapse">
                      <thead>
                        <tr className="backdrop-blur-md bg-gray-300/50 dark:bg-white/[0.06] border-b border-white/60 dark:border-white/10">
                          {[ "Partner", "Shipments", "Delivered", "Active","Performance"].map((heading) => (
                            <th
                              key={heading}
                              className="py-3 px-1.5 text-left text-[7px] font-semibold uppercase tracking-wider text-slate-900 dark:text-gray-400"
                            >
                              {heading}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {partners.map((p, i) => {
                          const pct = p.total ? Math.round((p.done / p.total) * 100) : 0;
                          const rankTint = [
                            "bg-amber-400/25 text-amber-700 dark:text-amber-300",
                            "bg-slate-400/25 text-slate-700 dark:text-slate-200",
                            "bg-orange-400/20 text-orange-700 dark:text-orange-300",
                            "bg-indigo-400/15 text-indigo-700 dark:text-indigo-300",
                            "bg-indigo-400/15 text-indigo-700 dark:text-indigo-300",
                          ][i] || "bg-indigo-400/15 text-indigo-700 dark:text-indigo-300";
                          return (
                            <tr
                              key={i}
                              className="border-b border-white/40 dark:border-white/[0.06] last:border-none hover:bg-white/40 dark:hover:bg-white/[0.05] transition-colors duration-200"
                            >
                              <td className="py-1 pr-2">
                                <div className="flex items-center h-7 rounded-xl bg-white/60 dark:bg-white/5 backdrop-blur-md px-2 w-fit">
                                  {p.name?.toLowerCase() === "delhivery" && (
                                    <img
                                      src={
                                        isDarkMode
                                          ? "/assets/images/DelhiveryWhite.png"
                                          : "/assets/images/Delhivery.png"
                                      }
                                      alt="Delhivery"
                                      className="h-4 w-auto object-contain"
                                    />
                                  )}
                                  {p.name?.toLowerCase() === "ecom" && (
                                    <img
                                      src={
                                        isDarkMode
                                          ? "/assets/images/logoecom.svg"
                                          : "/assets/images/ecom-express-logo.png"
                                      }
                                      alt="Ecom Express"
                                      className="h-8 w-auto object-contain"
                                    />
                                  )}
                                  {p.name?.toLowerCase() === "ekart" && (
                                    <img
                                      src="/assets/images/ekart.png"
                                      alt="Ekart"
                                      className="h-8 w-auto object-contain"
                                    />
                                  )}
                                  {p.name?.toLowerCase() === "xpressbees" && (
                                    <img
                                      src="/assets/images/xpressbess.png"
                                      alt="xpressbess"
                                      className="h-4 w-auto object-contain"
                                    />
                                  )}
                                  {p.name?.toLowerCase() === "bluedart" && (
                                    <div className="flex items-center">
                                      <img
                                        src="/assets/images/bluedart.png"
                                        alt="bluedart"
                                        className="h-[10px] w-auto object-contain"
                                      />
                                    </div>
                                  )}
                                  {!["delhivery", "ecom", "ekart", "xpressbees", "bluedart"].includes(
                                    p.name?.toLowerCase()
                                  ) && (
                                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-white/60 dark:bg-white/10 text-slate-700 dark:text-gray-200 backdrop-blur-md">
                                        {p.name || "Not Available"}
                                      </span>
                                    )}
                                </div>
                              </td>
                              <td className="py-3.5 px-4 text-xs font-bold text-slate-900 dark:text-white">
                                {p.total}
                              </td>
                              <td className="py-3.5 px-4">
                                <span className="inline-flex items-center gap-1 text-[11px] text-emerald-600 dark:text-emerald-400 font-medium">
                                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> {p.done}
                                </span>
                              </td>
                              <td className="py-3.5 pl-2 pr-6 text-center">
                                <span className="inline-flex items-center text-center gap-1 text-[11px] text-blue-600 dark:text-blue-400 font-medium">
                                  <span className="h-1.5 w-1.5 rounded-full bg-blue-500" /> {p.inprocess}
                                </span>
                              </td>
                              <td className="py-3.5 ">
                                <div className="flex items-center gap-2 ">
                                  <span className="text-[10px] font-semibold text-slate-600 dark:text-gray-300 w-8 text-right">
                                    {pct}%
                                  </span>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Pending shipments ── */}
            <div className={`rounded-3xl ${glass} mt-5 p-5`}>
              <div className="flex justify-between items-center mb-4">
                <div>
                  <h2 className="font-semibold text-slate-800 dark:text-gray-100">
                    Pending Shipments
                  </h2>
                  <p className="text-xs text-slate-500 dark:text-gray-400 mt-0.5">Orders awaiting fulfillment</p>
                </div>
                <button
                  onClick={() => navigate("/shipments/all")}
                  className="inline-flex items-center gap-1 shadow-md text-sm font-medium text-indigo-600 dark:text-indigo-300 hover:text-indigo-700 dark:hover:text-indigo-200 bg-white/40 dark:bg-white/5 hover:bg-white/60 dark:hover:bg-white/10 border border-white/50 dark:border-white/10 rounded-full px-3.5 py-1.5 backdrop-blur-md transition-colors"
                >
                  View All
                  <ArrowUpRight size={14} />
                </button>
              </div>

              <div className="rounded-2xl overflow-hidden backdrop-blur-xl bg-white/30 dark:bg-white/[0.03] border border-white/50 dark:border-white/10">
                <style>{`
    @keyframes fadeSlideIn {
      from { opacity: 0; transform: translateY(10px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .row-animate { animation: fadeSlideIn 0.35s ease both; }
    tr.row-animate td { border-bottom: 1px solid rgba(255,255,255,0.35); }
    tr.row-animate:last-child td { border-bottom: none; }
    tr.row-animate:hover td { background-color: rgba(255,255,255,0.3); transition: background 0.2s; }
    @keyframes cardIn {
      from { opacity: 0; transform: translateY(12px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .card-animate { animation: cardIn 0.3s ease both; }
  `}</style>

                {/* ── MOBILE CARD VIEW ── */}
                <div className="block md:hidden p-3 space-y-2.5">
                  {loadingOrders && (
                    <div className="py-10 text-center text-slate-500 dark:text-gray-400 flex items-center justify-center gap-2">
                      <Loader2 className="animate-spin text-indigo-500" size={16} />
                      Loading orders...
                    </div>
                  )}
                  {!loadingOrders && orders.length === 0 && (
                    <div className="py-12 text-center text-slate-500 dark:text-gray-400 flex flex-col items-center gap-2">
                      <Inbox size={22} className="text-slate-400 dark:text-gray-600" />
                      No pending shipments found
                    </div>
                  )}
                  {!loadingOrders && orders.slice(0, 8).map((o, i) => {
                    const isPending = o.status?.toLowerCase().includes('pending');
                    const isFailed = o.status?.toLowerCase() === 'failed';
                    const initials = `${(o.first_name || o.name || "?").charAt(0)}${(o.last_name || "").charAt(0)}`.toUpperCase();
                    return (
                      <div
                        key={i}
                        className="card-animate backdrop-blur-md bg-white/45 dark:bg-white/[0.05] rounded-2xl border border-white/55 dark:border-white/10 p-3.5 hover:bg-white/65 dark:hover:bg-white/[0.09] transition-colors"
                        style={{ animationDelay: `${i * 40}ms` }}
                      >
                        {/* Card Header */}
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex items-center gap-2">
                            <span className="inline-flex items-center justify-center  rounded-full bg-indigo-500/15 text-indigo-700 dark:text-indigo-300 text-[4px] font-bold">
                              {initials}
                            </span>
                            <div>
                              <div className="font-bold text-sm text-indigo-600 dark:text-indigo-300 leading-none">#{o.order_id || o.id}</div>
                              {o.user_id && <div className="text-[10px] text-slate-500 dark:text-gray-500 mt-1">UID: {o.user_id}</div>}
                            </div>
                          </div>
                          <span className={`inline-flex items-center gap-1 px-2.5 py-1 text-[10.5px] font-semibold rounded-full backdrop-blur-md
              ${isFailed ? 'bg-red-100/70 text-red-700 dark:bg-red-500/10 dark:text-red-300' :
                              isPending ? 'bg-amber-100/70 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300' :
                                'bg-emerald-100/70 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300'}`}>
                            <span className={`h-1.5 w-1.5 rounded-full ${isFailed ? 'bg-red-500' : isPending ? 'bg-amber-500' : 'bg-emerald-500'}`} />
                            {o.status || "Pending"}
                          </span>
                        </div>

                        {/* Card Body Grid */}
                        <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs bg-white/30 dark:bg-white/[0.02] rounded-xl p-2.5">
                          <div>
                            <div className="text-slate-500 dark:text-gray-500 mb-0.5">Recipient</div>
                            <div className="font-medium text-slate-800 dark:text-gray-200">{o.first_name || o.name || "—"} {o.last_name || ""}</div>
                            <div className="text-slate-500 dark:text-gray-500">{o.phone || ""}</div>
                          </div>
                          <div>
                            <div className="text-slate-500 dark:text-gray-500 mb-0.5">Payment</div>
                            <div className="font-semibold text-slate-800 dark:text-gray-200 capitalize">{o.payment_mode || "—"}</div>
                            {o.payment_mode === 'cod' && <div className="text-orange-500">COD: ₹{o.cod_amount}</div>}
                          </div>
                          <div>
                            <div className="text-slate-500 dark:text-gray-500 mb-0.5">Origin</div>
                            <div className="font-medium text-slate-800 dark:text-gray-200">{o.pickup_city || o.origin || "—"}</div>
                          </div>
                          <div>
                            <div className="text-slate-500 dark:text-gray-500 mb-0.5">Destination</div>
                            <div className="font-medium text-slate-800 dark:text-gray-200">{o.city || o.destination || "—"}</div>
                          </div>
                          <div>
                            <div className="text-slate-500 dark:text-gray-500 mb-0.5">Product</div>
                            <div className="text-slate-700 dark:text-gray-300 line-clamp-1">{o.products_desc || "—"}</div>
                            <div className="text-slate-500 dark:text-gray-500">Qty: {o.quantity} | {o.weight}g</div>
                          </div>
                          <div>
                            <div className="text-slate-500 dark:text-gray-500 mb-0.5">Date</div>
                            <div className="text-slate-700 dark:text-gray-300">{o.created_at ? o.created_at.split(" ")[0] : "—"}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* ── DESKTOP TABLE VIEW ── */}
                <div className="hidden md:block overflow-auto">
                  <table className="w-full border-collapse">
                    <thead>
                      <tr className="backdrop-blur-md bg-gray-300/50 dark:bg-white/[0.06] border-b border-white/50 dark:border-white/10">
                        {["Order", "ID", "Recipient", "Product Details", "Payment", "Origin", "Destination", "Date", "Status"].map((heading) => (
                          <th key={heading} className="py-3 px-3 text-left text-[10.5px] font-semibold uppercase tracking-wider text-slate-500 dark:text-gray-400">
                            {heading}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {loadingOrders && (
                        <tr>
                          <td colSpan="9" className="py-10 text-center text-slate-500 dark:text-gray-400">
                            <div className="flex items-center justify-center gap-2">
                              <Loader2 className="animate-spin text-indigo-500" size={16} />
                              Loading orders...
                            </div>
                          </td>
                        </tr>
                      )}
                      {!loadingOrders && orders.length === 0 && (
                        <tr>
                          <td colSpan="9" className="py-14 text-center text-slate-500 dark:text-gray-400">
                            <div className="flex flex-col items-center gap-2">
                              <Inbox size={22} className="text-slate-400 dark:text-gray-600" />
                              No pending shipments found
                            </div>
                          </td>
                        </tr>
                      )}
                      {!loadingOrders && orders.slice(0, 8).map((o, i) => {
                        const isPending = o.status?.toLowerCase().includes('pending');
                        const isFailed = o.status?.toLowerCase() === 'failed';
                        const initials = `${(o.first_name || o.name || "?").charAt(0)}${(o.last_name || "").charAt(0)}`.toUpperCase();
                        return (
                          <tr key={i} className="row-animate group transition-colors duration-200" style={{ animationDelay: `${i * 40}ms` }}>
                            <td className="py-3.5 px-3">
                              <span className="font-bold text-[10px] text-indigo-600 dark:text-indigo-300">{o.order_id || o.id}</span>
                            </td>
                            <td className="py-3.5 px-3 text-[10px] text-slate-600 dark:text-gray-400">{o.user_id || "—"}</td>
                            <td className="py-3.5 px-3">
                              <div className="flex items-center gap-2">
                                <span className="shrink-0 inline-flex items-center justify-center h-7 w-7 rounded-full bg-indigo-500/15 text-indigo-700 dark:text-indigo-300 text-[10px] font-bold">
                                  {initials}
                                </span>
                                <div>
                                  <div className="font-medium text-[10px] text-slate-800 dark:text-gray-200">{o.first_name || o.name || "—"} {o.last_name || ""}</div>
                                  <div className="text-[10px] text-slate-500 dark:text-gray-500">{o.phone || ""}</div>
                                </div>
                              </div>
                            </td>
                            <td className="py-3.5 px-3">
                              <div className="text-[10px] text-slate-800 dark:text-gray-200">{o.products_desc || "—"}</div>
                              <div className="text-[10px] text-slate-500 dark:text-gray-500 mt-0.5">Qty: {o.quantity} | Wt: {o.weight}g</div>
                              <div className="text-[10px] text-slate-500 dark:text-gray-500">{o.length}×{o.shipment_width}×{o.shipment_height} cm</div>
                            </td>
                            <td className="py-3.5 px-3">
                              <div className="font-semibold text-[10px] text-slate-800 dark:text-gray-200 capitalize">{o.payment_mode || "—"}</div>
                              {o.payment_mode === 'cod' && <div className="text-xs text-orange-500 font-medium">COD: ₹{o.cod_amount}</div>}
                            </td>
                            <td className="py-3.5 px-3 text-[10px]">
                              <div className="font-medium text-slate-800 dark:text-gray-200">{o.pickup_city || o.origin || "—"}</div>
                            </td>
                            <td className="py-3.5 px-3 text-[10px]">
                              <div className="font-medium text-slate-800 dark:text-gray-200">{o.city || o.destination || "—"}</div>
                            </td>
                            <td className="py-3.5 px-3 text-center text-[10px] text-slate-500 dark:text-gray-400">
                              {o.created_at ? o.created_at.split(" ")[0] : "—"}
                            </td>
                            <td className="py-3.5 px-3 text-center">
                              <span className={`inline-flex items-center gap-1 px-2.5 py-1 text-[10px] font-semibold rounded-full backdrop-blur-md ${isFailed ? 'bg-red-100/70 text-red-700 dark:bg-red-500/10 dark:text-red-300' : isPending ? 'bg-amber-100/70 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300' : 'bg-emerald-100/70 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300'}`}>
                                <span className={`h-1.5 w-1.5 rounded-full ${isFailed ? 'bg-red-500' : isPending ? 'bg-amber-500' : 'bg-emerald-500'}`} />
                                {o.status || "Pending"}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── KYC Pending Popup ── */}
      {isKycPending && showKycPopup && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm px-4"
          onClick={(e) => {
            e.stopPropagation();
            setShowKycPopup(false);
          }}
        >
          <div
            className="relative bg-white dark:bg-darkmodeColor rounded-2xl p-6 shadow-2xl max-w-sm w-full text-center"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowKycPopup(false)}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 dark:hover:text-white"
            >
              <X size={18} />
            </button>

            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-100 dark:bg-red-500/10 text-red-600 dark:text-red-400">
              <ShieldAlert size={28} />
            </div>

            <h2 className="text-lg font-bold text-slate-800 dark:text-white mb-2">
              KYC Verification Pending
            </h2>
            <p className="text-sm text-slate-500 dark:text-gray-400 mb-5">
              Your KYC is still pending. Please complete your KYC verification to continue using all features.
            </p>

            <div className="flex justify-center gap-3">
              <button
                onClick={() => setShowKycPopup(false)}
                className="px-4 py-2 rounded-full border border-gray-300 dark:border-white/10 text-sm text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/10 transition-colors"
              >
                Later
              </button>
              <button
                onClick={() => navigate("/updateKyc")}
                className="px-4 py-2 rounded-full bg-customPurple text-white text-sm font-medium hover:bg-purple-700 transition-colors"
              >
                Complete KYC
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}